import React, {memo} from 'react';
import {getError, hasError} from "../hooks/errors";
import {useSelector} from "react-redux";
import {RootState} from "../store";
import {Textarea} from "@material-tailwind/react";

interface OutlineTextareaProps {
    validated: boolean,
    name: string,
    fieldName: string,
    value: string | number| undefined,
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement> | undefined) => void,
    className?: string
}

const OutlineTextarea = ({validated, fieldName, value, name, onChange, className}: OutlineTextareaProps) => {
    const errors = useSelector((state: RootState) => state.validation.errors);

    return <div className={`max-w-md ${className ?? ''}`}>
        <Textarea success={!hasError(fieldName, errors) && validated}
               error={validated && hasError(fieldName, errors)}
               variant={'outlined'} label={name} onChange={onChange}
               value={value}
               className="inline-block dark:text-gray-500 dark:border-blue-gray-800 dark:placeholder-shown:border-blue-gray-800 dark:focus:border-blue-gray-800 dark:focus:border-t-transparent"
               labelProps={{className: "dark:after:border-blue-gray-800 dark:before:border-blue-gray-800 dark:peer-focus:text-white dark:peer-focus:before:!border-blue-gray-800 dark:peer-focus:after:!border-blue-gray-800"}}/>
        {validated && hasError(fieldName, errors) &&
            <label key={'error-' + fieldName}
                   className="mt-1 text-red-500 text-xs block">{getError(fieldName, errors)}</label>}
    </div>
}

export default memo(OutlineTextarea);
